import { render, staticRenderFns } from "./GoalWrapper.vue?vue&type=template&id=b7febfb2&"
import script from "./GoalWrapper.vue?vue&type=script&lang=js&"
export * from "./GoalWrapper.vue?vue&type=script&lang=js&"
import style0 from "./GoalWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports